import React, { memo } from 'react';

import { LoadingOverlay } from './components';
import { useLoading } from './hooks/useLoading';
import { LoadingProps } from './types';

/* eslint-disable react/prop-types */

/**
 * Modern loading component using Material UI
 *
 * Features:
 * - Material UI integration (CircularProgress, Backdrop, Typography)
 * - Theme-aware colors and styling
 * - Responsive design (adapts to mobile/desktop)
 * - Accessibility support (ARIA labels, screen reader friendly)
 * - Smooth animations and transitions
 * - Performance optimized with memoization
 * - Configurable spinner and overlay options
 * - Respects user's motion preferences
 *
 * @param spinner - Configuration for the loading spinner
 * @param overlay - Configuration for the backdrop overlay
 */
const Loading = memo<LoadingProps>(({ spinner = {}, overlay = {} }) => {
  const { isLoading, loadingText } = useLoading();

  return <LoadingOverlay open={isLoading} message={loadingText} spinner={spinner} backdrop={overlay.backdrop} />;
});

Loading.displayName = 'Loading';

export default Loading;

// Export additional components and utilities for advanced usage
export { LoadingOverlay, LoadingSpinner } from './components';
export * from './constants';
export { useLoading } from './hooks/useLoading';
export * from './types';
